import { orderBy } from 'lodash';
import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';

export const selectPayees = createSelector(
    (state: RootState) => Object.values(state.payees),
    (payees: any) => orderBy(payees, 'name')
)
